import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

import { HotelSearchedRoomRate } from '@hotels/hotel-results/entities/hotel-searched';

@Component({
  selector: 'app-by-hour-time-selector',
  templateUrl: './by-hour-time-selector.component.html',
  styleUrls: ['./by-hour-time-selector.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ByhourTimeSelectorComponent {

  @Input() roomRate: HotelSearchedRoomRate;
  @Input() selectedValue: string;
  
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

}
